import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: {
    health: () => import('./HealthPage.vue'),
    incidents: () => import('./IncidentsPage.vue'),
    funnel: () => import('./FunnelPage.vue'),
    callTimeline: () => import('./CallTimelinePage.vue'),
  },
} satisfies FeatureRoutes
